import { render, staticRenderFns } from "./PaymentBankForm.vue?vue&type=template&id=6518093a&scoped=true&"
import script from "./PaymentBankForm.vue?vue&type=script&lang=js&"
export * from "./PaymentBankForm.vue?vue&type=script&lang=js&"
import style0 from "./PaymentBankForm.vue?vue&type=style&index=0&id=6518093a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6518093a",
  null
  
)

export default component.exports